import { computed, toValue } from "vue";
import { useDefaultComponentTypes } from "./useDefaultComponentTypes";
import { isComponentType } from "../service/isComponentType";
export const useIsEnableableComponentType = (componentTypeName) => {
    const { defaultComponentTypes } = useDefaultComponentTypes();
    const isEnableableComponentType = computed(() => {
        return isComponentType(toValue(componentTypeName), [
            "integration-reward",
            "rule-v1",
            "rule-v9.0",
            "integration-reward-bank-supplier-v1",
            "integration-reward-bank-supplier-v2",
            "frontend-asset-v1",
            "content-v9.0",
        ], toValue(defaultComponentTypes));
    });
    return {
        isEnableableComponentType,
    };
};
